import React from "react"
import {SUPPORTED_LANGUAGES} from "../../../i18n";
import MDInput from "../../../materialDashboard/components/MDInput";
import {useTranslation} from "react-i18next";
import MenuItem from "@mui/material/MenuItem";


const LocaleAutocomplete = ({ MDInputProps ={}, ...props }) => {
    const {t} = useTranslation("inputs");

    return <MDInput label={t("localeAutocomplete.label")}
                    variant="standard"
                    select
                    {...props}>
        {
            Object.keys(SUPPORTED_LANGUAGES).map(key => (
                <MenuItem key={key} value={key}>{SUPPORTED_LANGUAGES[key]}</MenuItem>
            ))
        }
    </MDInput>
}


export default LocaleAutocomplete